import { useQuery } from "@tanstack/react-query";

import type { Claims } from "~/features/ar-dashboard/schemas/dashboard-schemas.ts";
import { claimsSchema } from "~/features/ar-dashboard/schemas/dashboard-schemas.ts";
import { apiRoutes } from "~/shared/services/api/api-routes.ts";
import { getAndValidateTraxAr } from "~/shared/services/api/fetch-client.ts";

import type { DashboardQueryParams } from "./dashboard-query-params.ts";
import { buildDashboardSearchParams } from "./dashboard-query-params.ts";

const emptyClaims: Claims = {
	validation: 0,
	activeClaims: 0,
	resolvedClaims: 0,
};

export const useClaims = (
	params: Pick<
		DashboardQueryParams,
		"ltlBrokerIds" | "primaryBrokerIds" | "customerIds"
	>,
) => {
	const { data, isLoading, isFetching, error, refetch } = useQuery({
		queryKey: [
			"dashboardClaims",
			params.ltlBrokerIds ?? [],
			params.primaryBrokerIds ?? [],
			params.customerIds ?? [],
		],
		queryFn: async ({ signal }) => {
			const searchParams = buildDashboardSearchParams(params);
			const url = `${apiRoutes.DASHBOARD_CLAIMS}?${searchParams.toString()}`;
			const result = await getAndValidateTraxAr(url, claimsSchema, {
				signal,
			});
			if (!result.success) {
				throw new Error(result.error);
			}
			return result.data;
		},
		staleTime: Infinity,
		gcTime: Infinity,
		refetchOnWindowFocus: false,
		refetchOnMount: false,
		refetchOnReconnect: false,
	});

	return {
		data: data ?? emptyClaims,
		isLoading,
		isFetching,
		error,
		refetch,
	};
};
